import styled from "styled-components"

export interface StyledOverlayProps {
  center?: boolean
}

export const StyledOverlay = styled.div<StyledOverlayProps>`
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  ${props => !props.center && (`
    @media (max-width: ${props.theme.breakPoints.tablet}) {
      overflow-y: scroll;
      align-items: flex-start;
      
      &::-webkit-scrollbar {
        display: none;
      }
    }
  `)}
`
export const StyledBG = styled.div`
  background: rgba(44,44,44,0.8);
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
`
export const StyledClose = styled.div`
  padding: 32px;
  cursor: pointer;
  background: rgba(44,44,44,.2);
  position: absolute;
  z-index: 10;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    padding: 24px;
  }
  @media (max-width: ${props => props.theme.breakPoints.mobile}) {
    padding: 16px;
  }

  & svg{
    color: ${props => props.theme.colors.white};
  }
`
export const StyledContainer = styled.div`
  width: 100%;
  height: 100vh;
  padding: 82px 32px 32px;
  z-index: 2;
  position: relative;
  overflow-Y: scroll;
  max-width: ${props => props.theme.breakPoints.desktop};
  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    padding: 24px;
    padding: 66px 24px 24px;
  }
  @media (max-width: ${props => props.theme.breakPoints.mobile}) {
    padding: 0;
    padding: 50px 0 0;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`
export const StyledContainerClose = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`